import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=4cc0998f&scoped=true&"
import script from "@/views/Users/Supervisor/Supervisor.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Supervisor/Supervisor.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Supervisor/supervisor.scss?vue&type=style&index=0&id=4cc0998f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc0998f",
  null
  
)

export default component.exports